import { authRoles } from 'app/auth';
import GuestRole from './GuestRole';

const GuestRoleConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: true
				},
				footer: {
					display: true
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authRoles.onlyGuest, // ['guest']
	routes: [
		{
			path: '/guest', // /auth/guest-role',
			component: GuestRole
		}
	]
};

export default GuestRoleConfig;